// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__QzTen","page-link":"styles_page-link__Cb0oz","custom_loader":"styles_custom_loader__pB5Mh","s1":"styles_s1__HDhSU"};